module.exports = "/_next/static/images/partner01-ca7cdebcd11b604d0423d1965fd17fbe.png";